<template>
  <div id="Informations">
    <div class="header flex-between">
      <div class="header-text">
        <h1>会员信息管理</h1>
      </div>
      <div class="header-button">
        <el-button
            v-if="jurisdiction.search"
            icon="iconfont icon-sousuo1"
            @click="onSubmit"
        >查询</el-button
        >
        <el-button
            v-if="jurisdiction.search"
            icon="el-icon-notebook-2"
            @click="conditionDialog = true"
        >展开隐藏条件</el-button
        >
        <el-button
            v-if="jurisdiction.create"
            icon="iconfont icon-chuangjian1"
            @click="createDialog"
        >创建</el-button
        >
        <el-button
            v-if="jurisdiction.Import"
            icon="iconfont icon-daoru1"
            @click="memberFreezeImport = true"
        >导入</el-button
        >
        <el-button
            v-if="jurisdiction.Import"
            icon="el-icon-download"
            @click="(downloadShow = true), getDownladList()"
        >下载导入结果</el-button
        >
        <el-button
            v-if="jurisdiction.edit"
            icon="iconfont icon-xiugai1"
            @click="modifyBtn"
        >修改会员</el-button
        >
        <el-button
            v-if="jurisdiction.synchronization"
            icon="iconfont icon-xiugai1"
            @click="Synchronization"
        >同步</el-button
        >
        <el-button
            v-if="jurisdiction.delete"
            icon="iconfont icon-a-shanchu11"
            @click="deletePopup"
        >删除</el-button
        >
        <el-button
            v-if="jurisdiction.look"
            icon="iconfont icon-chakan1"
            @click="getToLook"
        >查看会员</el-button
        >
      </div>
    </div>
    <!-- 同步提示框 -->
    <div class="Enabledisable">
      <el-dialog
          width="20%"
          title="同步提示框"
          :visible.sync="EnabledisableFormVisible"
          :close-on-click-modal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
                class="iconfont icon-jingshi"
                style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">同步</span>此会员?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Enabledisableqd">确 定</el-button>
          <el-button @click="EnabledisableFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 导入保存确认对话框 -->
    <div class="import">
      <el-dialog
          title="导入新会员-导入"
          :visible.sync="memberFreezeImport"
          :close-on-click-modal="false"
          width="40%"
      >
        <div>
          <el-form
              size="mini"
              label-width="155px"
              ref="newUploadForm"
              enctype="multipart/form-data"
          >
            <el-form-item label="选择待导入会员文件">
              <el-row :gutter="10">
                <el-col :span="20">
                  <el-input
                      style="width: 100%"
                      v-model="filename"
                      :readonly="true"
                      placeholder="请选择文件名"
                      disabled
                  >
                  </el-input>
                </el-col>
                <el-col :span="2">
                  <el-upload
                      class="upload"
                      action="#"
                      :show-file-list="false"
                      :on-change="handleExcel"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      :auto-upload="false"
                  >
                    <el-button>选择</el-button>
                  </el-upload>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button icon="el-icon-download" @click="downloadTemplateBtn"
          >下载模板</el-button
          >
        </span>
      </el-dialog>
      <!-- 会员导入下载弹窗
      <div class="import">
        <el-dialog title="导入新会员"
                   :visible.sync="deFaultIsDerived"
                   :close-on-click-modal="false"
                   width="40%">
          <div class="resui"
               style="height: 85px">
            <div>成功处理行数: {{ succeedInfo.sucNum }}</div>
            <div style="margin-top: 8px">
              失败处理行数: {{ succeedInfo.errNum }}
            </div>
            <div>
              处理结果文件:
              <span style="text-decoration: underline; color: skyblue">{{
                succeedInfo.fileUrl
              }}</span>
              <el-button size
                         icon="el-icon-download"
                         @click.stop="downFile(succeedInfo.fileUrl)"
                         style="margin-left: 10px">下载</el-button>
            </div>
          </div>
        </el-dialog>
      </div> -->
    </div>
    <!-- 下载弹窗 -->
    <el-dialog
        append-to-body
        width="50%"
        :visible.sync="downloadShow"
        title="下载导入结果"
    >
      <el-table
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="downloadData"
          tooltip-effect="dark"
          style="width: 100%"
      >
        <!-- v-loading="loading"
        v-el-table-infinite-scroll="load"
        infinite-scroll-disabled="onLoading" -->
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column
            prop="startTime"
            label="导入开始时间"
        ></el-table-column>

        <el-table-column prop="endTime" label="导入结束时间"></el-table-column>

        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button
                icon="el-icon-download"
                v-if="scope.row.isComplate"
                @click="download(scope.row.downloadUrl)"
            >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadShow = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 创建会员弹出框 -->
    <div class="establish">
      <el-dialog
          width="45%"
          title="新建会员"
          :close-on-click-modal="false"
          :visible.sync="dialogFormVisible"
      >
        <div>
          <el-form
              size="mini"
              :model="createdTableList"
              ref="ruleFormRef"
              :rules="createRules"
              label-width="140px"
          >
            <el-tabs type="card" v-model="activeName" stretch>
              <el-tab-pane label="客户信息" name="first">
                <div>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="客户姓" prop="lastName">
                        <el-input
                            v-model="createdTableList.lastName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="客户名" prop="firstName">
                        <el-input
                            style="width: 100%"
                            v-model="createdTableList.firstName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="性别" prop="gender">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.gender"
                        >
                          <el-option
                              v-for="item in optionsGender"
                              :key="item.value"
                              :value="item.value"
                              :label="item.label"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="出生日期" prop="birthday">
                        <el-date-picker
                            style="width: 100%"
                            v-model="createdTableList.birthday"
                            type="date"
                            placeholder="选择日期"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="移动电话" prop="mobile">
                        <el-input v-model="createdTableList.mobile"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="电子邮件">
                        <el-input
                            v-model="createdTableList.userEmail"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="电话">
                        <el-input v-model="createdTableList.telCode"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="行业">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.industryID"
                        >
                          <el-option
                              v-for="item in definedData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="国家或地区">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.countryID"
                            @change="countryChange"
                        >
                          <el-option
                              v-for="item in countryData"
                              :key="item.countryID"
                              :value="item.countryID"
                              :label="item.countryName_cn"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="省">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.stateID"
                            @change="provinceChange"
                        >
                          <el-option
                              v-for="item in provinceData"
                              :key="item.stateID"
                              :value="item.stateID"
                              :label="item.stateName_cn"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="市">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.cityID"
                        >
                          <el-option
                              v-for="item in cityData"
                              :key="item.cityID"
                              :value="item.cityID"
                              :label="item.cityName_cn"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="通讯地址">
                        <el-input
                            v-model="createdTableList.mailAddress"
                            autocomplete="off"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="常驻地址">
                        <el-input
                            v-model="createdTableList.permanentAddress"
                            autocomplete="off"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="业务引流" prop="busskind">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.busskind"
                        >
                          <el-option
                              v-for="item in bussBindData"
                              :key="item.busskind"
                              :value="item.busskind"
                              :label="item.bussnameCn"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-tab-pane>
              <el-tab-pane label="会员信息" name="second">
                <div>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="会员等级">
                        <el-input
                            style="width: 100%"
                            disabled
                            v-model="createdTableList.levelID"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="会员卡号">
                        <el-input
                            style="width: 100%"
                            disabled
                            v-model="createdTableList.cardNo"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="维护店" prop="serviceOrgID">
                        <el-autocomplete
                            v-model="createdTableList.serviceOrgID"
                            :fetch-suggestions="querySearch"
                            placeholder="请输入门店编号"
                            @select="handleSelect"
                        >
                        </el-autocomplete>
                        <!-- <el-select style="width: 100%"
                                   v-model="createdTableList.serviceOrgID">
                          <el-option v-for="item in optionsShop"
                                     :key="item.shopID"
                                     :label="item.shopCode"
                                     :value="item.shopID">
                          </el-option>
                        </el-select> -->
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="当前维护人" prop="serviceEmpID">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.serviceEmpID"
                        >
                          <el-option
                              v-for="item in MaintainerData"
                              :key="item.EmpID"
                              :value="item.EmpID"
                              :label="item.EmpName"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="注册门店" prop="registOrgID">
                        <!-- <el-select style="width: 100%"
                                   v-model="createdTableList.registOrgID">
                          <el-option v-for="item in optionsShop"
                                     :key="item.shopID"
                                     :label="item.shopCode"
                                     :value="item.shopID">
                          </el-option>
                        </el-select> -->
                        <el-autocomplete
                            v-model="createdTableList.registOrgID"
                            :fetch-suggestions="querySearch"
                            placeholder="请输入门店编号"
                            @select="handleSelecting"
                        >
                        </el-autocomplete>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="注册日期">
                        <el-date-picker
                            disabled
                            style="width: 100%"
                            v-model="createdTableList.registDate"
                            type="datetime"
                            placeholder="默认当前日期"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="客户来源">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.custSourceID"
                        >
                          <el-option
                              v-for="item in sourceData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="客户来源-小类">
                        <el-input
                            v-model="createdTableList.custSourceNotes"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">

                    <el-col :span="12">
                      <el-form-item label="联系方式添加情况">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.contactInfoID"
                            @change="changeContactInfo"
                        >
                          <el-option
                              v-for="item in contactInfoData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="是否退货高频" prop="type">
                        <el-checkbox
                            name="type"
                            v-model="createdTableList.isHighRB"
                        ></el-checkbox>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">

                    <el-col :span="12">
                      <el-form-item label="会员活跃度">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.activityLevel"
                            @change="changeActivityLevel"
                        >
                          <el-option
                              v-for="item in activityLevelData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="会员TAG:可选">
                        <div class="edit_dev">
                          <el-transfer
                              :titles="['可选择', '已选择']"
                              :props="{
                              key: 'userDefineID',
                              label: 'description_CN',
                            }"
                              v-model="createdTableList.attrIDArray[0]"
                              :data="memberDataList"
                              @change="changeTAG"
                          ></el-transfer>
                        </div>
                      </el-form-item>
                    </el-col>
                  </el-row>

                </div>
              </el-tab-pane>
              <el-tab-pane label="尺码信息" name="third">
                <div>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="身高">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.heightID"
                        >
                          <el-option
                              v-for="item in heightData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="体重">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.weightID"
                            autocomplete="off"
                        >
                          <el-option
                              v-for="item in weightData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="上衣尺码">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.topSize"
                        >
                          <el-option
                              v-for="(item, index) in sizeData"
                              :key="index"
                              :value="item.description_CN"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="下装尺码">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.bottomSize"
                        >
                          <el-option
                              v-for="item in sizeData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="裙装尺码">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.skirtSize"
                        >
                          <el-option
                              v-for="item in sizeData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="鞋码">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.shoeSize"
                        >
                          <el-option
                              v-for="item in shoeSizeData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-tab-pane>
              <el-tab-pane label="行为偏好" name="fourth" class="el-tab-pane4">
                <div
                    style="height: 31.25rem; overflow-y: auto; overflow-x: hidden"
                >
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="客户性格类型:交流">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.talkativeID"
                        >
                          <el-option
                              v-for="item in talkativeData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="客户性格类型:买单">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.opionionID2"
                        >
                          <el-option
                              v-for="item in checkData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="客户性格类型:决策">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.opionionID"
                        >
                          <el-option
                              v-for="item in decisionData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="颜色偏好">
                        <el-input
                            v-model="createdTableList.colorPreference"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="特殊产品偏好">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[1]"
                            :data="specialData"
                            @change="changeSpecial"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="客户着衣风格">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[2]"
                            :data="clothingStyleData"
                            @change="changeClothingStyle"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="到店时间偏好">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[3]"
                            :data="preferenceData"
                            @change="changePreferenceData"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="邀约敏感点">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[4]"
                            :data="sensitiveData"
                            @change="changeStyle"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="兴趣爱好">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[5]"
                            :data="hobbyData"
                            @change="changeClothing"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="经常穿着品牌">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[6]"
                            :data="regularBrandData"
                            @change="changePinPai"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="日常奢侈品购买渠道">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[7]"
                            :data="dailyData"
                            @change="changePFD"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="奢侈品信息获取渠道">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[8]"
                            :data="informationData"
                            @change="changeQuDao"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="子女情况">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.hasChild"
                            autocomplete="off"
                        >
                          <el-option
                              v-for="item in optionsChildren"
                              :key="item.value"
                              :value="item.value"
                              :label="item.label"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="最小子女出生年">
                        <el-input
                            v-model="createdTableList.childBirthYear"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="宗教信仰">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.religiousID"
                            autocomplete="off"
                        >
                          <el-option
                              v-for="item in religionData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="不良销售记录">
                        <el-input
                            v-model="createdTableList.badRecord"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="四大客户群体">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.custGroupID"
                        >
                          <el-option
                              v-for="item in fourGroupsData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="六小类客户群体">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.sixTypeID"
                        >
                          <el-option
                              v-for="item in sixGroupsData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="注意点">
                        <el-input
                            v-model="createdTableList.arriveShopTimeNotes"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12"></el-col>
                  </el-row>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="createTableSave">保存</el-button>
          <el-button @click="cancelBtn">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改会员弹出窗 -->
    <div class="modification">
      <el-dialog
          :close-on-click-modal="false"
          width="45%"
          title="会员信息-修改会员"
          :visible.sync="modificationFormVisible"
      >
        <div>
          <el-form
              size="mini"
              :model="createdTableList"
              :rules="createRules"
              label-width="140px"
          >
            <el-tabs type="card" v-model="modifyActiveName" stretch>
              <el-tab-pane
                  label="基础信息"
                  name="first"
                  style="height: 35.25rem; overflow-y: auto; overflow-x: hidden"
              >
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="客户姓" prop="lastName">
                      <el-input v-model="createdTableList.lastName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="客户名" prop="firstName">
                      <el-input
                          style="width: 100%"
                          v-model="createdTableList.firstName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="会员等级" prop="levelID">
                      <el-select
                          v-model="createdTableList.levelID"
                          style="width: 100%"
                          disabled
                      >
                        <el-option
                            v-for="item in searchOptions"
                            :key="item.levelID"
                            :value="item.levelID"
                            :label="item.levelName_cn"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="会员卡号">
                      <el-input
                          style="width: 100%"
                          v-model="createdTableList.cardNo"
                          disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="维护店">
                      <el-select
                          disabled
                          style="width: 100%"
                          v-model="createdTableList.serviceOrgID"
                      >
                        <el-option
                            v-for="item in optionsShop"
                            :key="item.shopID"
                            :label="item.shopCode"
                            :value="item.shopID"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="当前维护人">
                      <el-select
                          disabled
                          style="width: 100%"
                          v-model="createdTableList.serviceEmpName"
                      >
                        <el-option
                            v-for="item in MaintainerData"
                            :key="item.EmpID"
                            :label="item.EmpName"
                            :value="item.EmpID"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="性别" prop="gender">
                      <el-select
                          style="width: 100%"
                          v-model="createdTableList.gender"
                      >
                        <el-option
                            v-for="item in optionsGender"
                            :key="item.value"
                            :value="item.value"
                            :label="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="出生日期" prop="birthday">
                      <el-date-picker
                          style="width: 100%"
                          v-model="createdTableList.birthday"
                          type="date"
                          placeholder="选择日期"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="移动电话" prop="mobile">
                      <el-input v-model="createdTableList.mobile"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="电子邮件">
                      <el-input v-model="createdTableList.userEmail"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="电话">
                      <el-input v-model="createdTableList.telCode"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="行业">
                      <el-select
                          style="width: 100%"
                          v-model="createdTableList.industryID"
                      >
                        <el-option
                            v-for="item in definedData"
                            :key="item.userDefineID"
                            :value="item.userDefineID"
                            :label="item.description_CN"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="国家或地区">
                      <el-select
                          style="width: 100%"
                          v-model="createdTableList.countryID"
                          @change="countryChange"
                      >
                        <el-option
                            v-for="item in countryData"
                            :key="item.countryID"
                            :value="item.countryID"
                            :label="item.countryName_cn"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="省">
                      <el-select
                          style="width: 100%"
                          v-model="createdTableList.stateID"
                          @change="provinceChange"
                      >
                        <el-option
                            v-for="item in provinceData"
                            :key="item.stateID"
                            :value="item.stateID"
                            :label="item.stateName_cn"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="市">
                      <el-select
                          style="width: 100%"
                          v-model="createdTableList.cityID"
                      >
                        <el-option
                            v-for="item in cityData"
                            :key="item.cityID"
                            :value="item.cityID"
                            :label="item.cityName_cn"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="通讯地址">
                      <el-input
                          v-model="createdTableList.mailAddress"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="常驻地址">
                      <el-input
                          v-model="createdTableList.permanentAddress"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="小程序OpenID">
                      <el-input
                          v-model="createdTableList.weChatOpenID"
                          disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="UnionID">
                      <el-input
                          v-model="createdTableList.unionID"
                          disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12"> </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="当期可用积分">
                      <el-input
                          v-model="createdTableList.currAvailPoint"
                          disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="待取消积分">
                      <el-input
                          v-model="createdTableList.loseEfficacyPoints"
                          disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-tab-pane>

              <el-tab-pane
                  label="会员附加信息"
                  name="second"
                  style="height: 35.25rem; overflow-y: auto; overflow-x: hidden"
              >
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="注册门店">
                      <!-- <el-select style="width: 100%"
                                 v-model="createdTableList.registOrgID">
                        <el-option v-for="item in optionsShop"
                                   :key="item.shopID"
                                   :label="item.shopCode"
                                   :value="item.shopID">
                        </el-option>
                      </el-select> -->
                      <el-autocomplete
                          v-model="createdTableList.registOrgCode"
                          :fetch-suggestions="querySearch"
                          placeholder="请输入门店编号"
                          @select="handleSelectest"
                      >
                      </el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="注册日期">
                      <el-input
                          v-model="createdTableList.registDate"
                          disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="最新升级门店">
                      <el-select
                          disabled
                          style="width: 100%"
                          v-model="createdTableList.updateLvlOrgID"
                      >
                        <el-option
                            v-for="item in optionsShop"
                            :key="item.shopID"
                            :label="item.shopCode"
                            :value="item.shopID"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最新升级日期">
                      <el-date-picker
                          style="width: 100%"
                          v-model="createdTableList.updateLvlDate"
                          type="date"
                          placeholder="选择日期"
                          disabled
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="保级起始日期">
                      <el-date-picker
                          style="width: 100%"
                          v-model="createdTableList.lvlStartDate"
                          type="date"
                          placeholder="选择日期"
                          disabled
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="保级终止日期">
                      <el-date-picker
                          style="width: 100%"
                          v-model="createdTableList.lvlExpireDate"
                          type="date"
                          placeholder="选择日期"
                          disabled
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="会员来源">
                      <el-select
                          style="width: 100%"
                          v-model="createdTableList.custSourceID"
                      >
                        <el-option
                            v-for="item in sourceData"
                            :key="item.userDefineID"
                            :value="item.userDefineID"
                            :label="item.description_CN"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="会员来源-备注">
                      <el-input
                          v-model="createdTableList.custSourceNotes"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="联系方式添加情况">
                      <el-select
                          style="width: 100%"
                          v-model="createdTableList.contactInfoID"
                          @change="changeContactInfo"
                      >
                        <el-option
                            v-for="item in contactInfoData"
                            :key="item.userDefineID"
                            :value="item.userDefineID"
                            :label="item.description_CN"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">

                  <el-col :span="12">
                    <el-form-item label="会员活跃度">
                      <el-select
                          style="width: 100%"
                          v-model="createdTableList.activityLevel"
                          @change="changeActivityLevel"
                      >
                        <el-option
                            v-for="item in activityLevelData"
                            :key="item.userDefineID"
                            :value="item.userDefineID"
                            :label="item.description_CN"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="商场VIP">
                      <el-checkbox
                          v-model="createdTableList.isMillVIP"
                      ></el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="VIC会员">
                      <el-checkbox
                          disabled
                          v-model="createdTableList.custType"
                      ></el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="推荐人">
                      <el-input
                          style="width: 100%"
                          v-model="createdTableList.referrerID"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="当前保级消费总金额">
                      <el-input
                          style="width: 100%"
                          v-model="createdTableList.lvlAmount"
                          disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="50">
                  <el-col :span="24">
                    <el-form-item label="会员TAG:可选">
                      <el-transfer
                          :titles="['可选择', '已选择']"
                          :props="{
                          key: 'userDefineID',
                          label: 'description_CN',
                        }"
                          v-model="createdTableList.attrIDArray[0]"
                          :data="memberDataList"
                          @change="changeTAG"
                      ></el-transfer>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="积分信息" name="third">
                <div>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="当期可用积分">
                        <el-input
                            v-model="createdTableList.currAvailPoint"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="待取消积分">
                        <el-input
                            v-model="createdTableList.loseEfficacyPoints"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="今年累积积分">
                        <el-input
                            v-model="createdTableList.currYearPoints"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="去年累积积分">
                        <el-input
                            v-model="createdTableList.preYearPoints"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="总累积积分">
                        <el-input
                            v-model="createdTableList.allPoints"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="待生效积分">
                        <el-input
                            v-model="createdTableList.pendingPoints"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="今年已使用积分">
                        <el-input
                            v-model="createdTableList.currExchangePoints"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="去年已使用积分">
                        <el-input
                            v-model="createdTableList.prevExchangePoints"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-tab-pane>
              <el-tab-pane
                  label="消费信息"
                  name="fourth"
                  style="height: 35.25rem; overflow-y: auto; overflow-x: hidden"
              >
                <div>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="今年消费额">
                        <el-input
                            v-model="createdTableList.currYearAmount"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="平均客单价">
                        <el-input
                            v-model="createdTableList.avgSheetAmt"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="今年消费次数合计">
                        <el-input
                            v-model="createdTableList.currYearSaleTimes"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Top1单价">
                        <el-input
                            v-model="createdTableList.sheetTopAmt1"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="今年目标消费额">
                        <el-input
                            v-model="createdTableList.currTargetAmt"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Top2单价">
                        <el-input
                            v-model="createdTableList.sheetTopAmt2"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="今年目标消费次数">
                        <el-input
                            v-model="createdTableList.currTargetSaleTimes"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Top3单价">
                        <el-input
                            v-model="createdTableList.sheetTopAmt3"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="VIP消费行为标签">
                        <el-input
                            v-model="createdTableList.saleTagID"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="平均折扣">
                        <el-input
                            v-model="createdTableList.avgDiscount"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="是否退换货高频">
                        <el-checkbox
                            v-model="createdTableList.isHighRB"
                            disabled
                        ></el-checkbox>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12"></el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="最近购买日">
                        <el-input
                            v-model="createdTableList.lastSaleDate"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="购买数量合计">
                        <el-input
                            v-model="createdTableList.saleAQty"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="最近购买金额">
                        <el-input
                            v-model="createdTableList.saleAAmount"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12"></el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="最近365天消费额">
                        <el-input
                            v-model="createdTableList.lastYearAmount"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12"></el-col>
                  </el-row>
                  <hr />
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="去年消费额">
                        <el-input
                            v-model="createdTableList.prevYearAmount"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="最近12个月消费次数最多门店">
                        <el-input
                            v-model="createdTableList.yearMaxSaleOrgList"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="去年消费次数合计">
                        <el-input
                            v-model="createdTableList.prevYearSaleTimes"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="今年维护店消费次数">
                        <el-input
                            v-model="createdTableList.currYearServSaleTimes"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="购买金额合计">
                        <el-input
                            v-model="createdTableList.saleAAmount"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="当前可能降级级别">
                        <el-select v-model="createdTableList.levelID" disabled>
                          <el-option
                              v-for="item in searchOptions"
                              :key="item.levelID"
                              :value="item.levelID"
                              :label="item.levelName_cn"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="升级后累计消费">
                        <el-input
                            v-model="createdTableList.lastLvlAmount"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="保级成功">
                        <el-checkbox
                            v-model="createdTableList.hasRelegation"
                            disabled
                        ></el-checkbox>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-tab-pane>
              <el-tab-pane label="尺码信息" name="five">
                <div>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="身高">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.heightID"
                            autocomplete="off"
                        >
                          <el-option
                              v-for="item in heightData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="体重">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.weightID"
                            autocomplete="off"
                        >
                          <el-option
                              v-for="item in weightData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="上衣尺码">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.topSize"
                        >
                          <el-option
                              v-for="(item, index) in sizeData"
                              :key="index"
                              :value="item.description_CN"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="下装尺码">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.bottomSize"
                        >
                          <el-option
                              v-for="(item, index) in sizeData"
                              :key="index"
                              :value="item.description_CN"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="裙装尺码">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.skirtSize"
                        >
                          <el-option
                              v-for="(item, index) in sizeData"
                              :key="index"
                              :value="item.description_CN"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="鞋码">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.shoeSize"
                        >
                          <el-option
                              v-for="(item, index) in shoeSizeData"
                              :key="index"
                              :value="item.description_CN"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-tab-pane>
              <el-tab-pane
                  label="行为偏好"
                  name="six"
                  style="height: 35.25rem; overflow-y: auto; overflow-x: hidden"
              >
                <div>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="客户性格类型：交流">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.talkativeID"
                        >
                          <el-option
                              v-for="item in talkativeData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="客户性格类型：买单">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.opionionID2"
                        >
                          <el-option
                              v-for="item in checkData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="客户性格类型:决策">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.opionionID"
                        >
                          <el-option
                              v-for="item in decisionData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="颜色偏好">
                        <el-input
                            v-model="createdTableList.colorPreference"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="特殊产品偏好">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[1]"
                            :data="specialData"
                            @change="changeSpecial"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="客户着衣风格">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[2]"
                            :data="clothingStyleData"
                            @change="changeClothingStyle"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="到店时间偏好">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[3]"
                            :data="preferenceData"
                            @change="changePreferenceData"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="邀约敏感点">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[4]"
                            :data="sensitiveData"
                            @change="changeStyle"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="兴趣爱好">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[5]"
                            :data="hobbyData"
                            @change="changeClothing"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="经常穿着品牌">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[6]"
                            :data="regularBrandData"
                            @change="changePinPai"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="日常奢侈品购买渠道">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[7]"
                            :data="dailyData"
                            @change="changePFD"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <el-form-item label="奢侈品信息获取渠道">
                        <el-transfer
                            :titles="['可选项', '已选择']"
                            :props="{
                            key: 'userDefineID',
                            label: 'description_CN',
                          }"
                            v-model="createdTableList.attrIDArray[8]"
                            :data="informationData"
                            @change="changeQuDao"
                        ></el-transfer>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="子女情况">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.hasChild"
                            autocomplete="off"
                        >
                          <el-option
                              v-for="item in optionsChildren"
                              :key="item.value"
                              :value="item.value"
                              :label="item.label"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="最小子女出生年">
                        <el-input
                            v-model="createdTableList.childBirthYear"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="宗教信仰">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.religiousID"
                            autocomplete="off"
                        >
                          <el-option
                              v-for="item in religionData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="不良销售记录">
                        <el-input
                            v-model="createdTableList.badRecord"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="四大客户群体">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.custGroupID"
                        >
                          <el-option
                              v-for="item in fourGroupsData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="六小类客户群体">
                        <el-select
                            style="width: 100%"
                            v-model="createdTableList.sixTypeID"
                        >
                          <el-option
                              v-for="item in sixGroupsData"
                              :key="item.userDefineID"
                              :value="item.userDefineID"
                              :label="item.description_CN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="50">
                    <el-col :span="12">
                      <el-form-item label="注意点">
                        <el-input
                            v-model="createdTableList.arriveShopTimeNotes"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12"></el-col>
                  </el-row>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button style="width: 7.5rem" @click="modifyBtnSave"
          >保存</el-button
          >
          <el-button
              style="width: 7.5rem"
              @click="modificationFormVisible = false"
          >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
          width="20%"
          title="删除会员确认取消对话框"
          :visible.sync="deleteFormVisible"
      >
        <div style="height: 3.125rem; font-size: 0.875rem; font-weight: 700">
          <p>
            <i
                class="iconfont icon-jingshi"
                style="font-size: 1.75rem; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">删除</span>会员信息?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="deleteForm">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 查询表单 -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form label-width="90px" :model="formInline" size="small">
          <el-row :gutter="100">
            <el-col :span="8">
              <el-form-item label-width="110px" label="会员卡\姓名\手机号">
                <el-input v-model.trim="formInline.serach" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="维护店">
                <el-input v-model="formInline.shopCode" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="当前维护人">
                <el-input v-model="formInline.empCode" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="100">
            <el-col :span="8">
              <el-form-item label-width="110px" label="是否是奥莱会员">
                <el-select
                    v-model="formInline.regionKind"
                    style="width: 100%"
                    placeholder="请选择"
                >
                  <el-option label="是" value="1"> </el-option>
                  <el-option label="否" value="0"> </el-option>
                  <el-option label="全部" value=""> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <!-- 筛选条件弹窗 -->
    <el-dialog
        append-to-body
        width="1200px"
        :visible.sync="conditionDialog"
        :close-on-click-modal="false"
    >
      <el-row>
        <el-col :span="12">
          <el-form
              :model="formInline"
              size="small"
              :inline="true"
              label-width="130px"
          >
            <el-form-item label="卡号">
              <el-input v-model="formInline.cardNo"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="formInline.name"></el-input>
            </el-form-item>
            <el-form-item label="电话号码">
              <el-input v-model="formInline.mobile"></el-input>
            </el-form-item>
            <el-form-item label="维护区域">
              <el-select
                  v-model="formInline.regionID"
                  multiple
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in Regioncax"
                    :key="item.id"
                    :label="item.lable"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="维护店">
              <el-col :span="16">
                <textarea rows="8" v-model="ServiceOrgName" readonly></textarea>
              </el-col>
              <el-col :span="8">
                <el-button
                    style="margin-left: 10px"
                    @click="
                    (outletVisible = true),
                      (flag = 1),
                      (shopId = formInline.shopIds)
                  "
                >选择门店</el-button
                >
              </el-col>
            </el-form-item>
            <el-form-item label="维护人">
              <el-input v-model="formInline.empCode"></el-input>
            </el-form-item>
            <el-form-item label="注册日期">
              <el-date-picker
                  v-model="dateValue"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="省份">
              <el-input v-model="formInline.provinceName"></el-input>
              <!-- <el-select
                filterable
                style="width: 100%"
                @change="provinceChange"
                v-model="aa"
              >
                <el-option
                  v-for="item in provinceData"
                  :key="item.stateID"
                  :value="item.stateID"
                  :label="item.stateName_cn"
                ></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="城市">
              <el-input v-model="formInline.cityName"></el-input>
              <!-- <el-select v-model="bb" style="width: 100%" @focus="focus">
                <el-option
                  v-for="item in cityData"
                  :key="item.cityID"
                  :value="item.cityID"
                  :label="item.cityName_en"
                ></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="会员等级">
              <el-select
                  style="width: 100%"
                  multiple
                  v-model="formInline.levelID"
              >
                <el-option
                    v-for="item in checkbooksData"
                    :key="item.levelID"
                    :value="item.levelID"
                    :label="item.levelName_cn"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="生日">
              <el-date-picker
                v-model="dateValue2"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item> -->
            <el-form-item label="生日所在月份" style="width: 100%">
              <div class="flex-between">
                <el-select
                    style="width: 45%"
                    v-model="formInline.birthMonthStart"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in months"
                      :key="item"
                      :label="item + '月'"
                      :value="item"
                  >
                  </el-option>
                </el-select>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-select
                    style="width: 45%"
                    v-model="formInline.birthMonthEnd"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in months"
                      :key="item"
                      :label="item + '月'"
                      :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="生日所在日期" style="width: 100%">
              <div class="flex-between">
                <el-select
                    style="width: 45%"
                    v-model="formInline.birthDateStart"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in days"
                      :key="item"
                      :label="item + '日'"
                      :value="item"
                  >
                  </el-option>
                </el-select>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-select
                    style="width: 45%"
                    v-model="formInline.birthDateEnd"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in days"
                      :key="item"
                      :label="item + '日'"
                      :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="年龄">
              <div class="flex-between">
                <el-input v-model="formInline.ageMin"></el-input>
                <span style="margin: 0 1rem 0 1rem">到</span>
                <el-input v-model="formInline.ageMax"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="最近购买日">
              <el-date-picker
                  v-model="dateValue3"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="会员TAG">
              <el-select
                  v-model="formInline.tagIds"
                  multiple
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in memberTagList"
                    :key="item.userDefineID"
                    :label="item.description_CN"
                    :value="item.userDefineID"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否商城VIP">
              <el-select v-model="formInline.isMillVIP" placeholder="请选择">
                <el-option value="" label="所有"></el-option>
                <el-option value="1" label="是"></el-option>

                <el-option value="0" label="否"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="非分配维护人">
              <el-select v-model="formInline.isServiceEmp" placeholder="请选择">
                <el-option value="" label="所有"></el-option>

                <el-option value="1" label="已分配"></el-option>

                <el-option value="0" label="未分配"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="今年消费额">
              <div class="flex-between">
                <el-input
                    v-model="formInline.currYearAmountMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.currYearAmountMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="去年消费额">
              <div class="flex-between">
                <el-input
                    v-model="formInline.prevYearAmountMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.prevYearAmountMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="最近一年消费额">
              <div class="flex-between">
                <el-input
                    v-model="formInline.lastYearAmountMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.lastYearAmountMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="TOP1客单价">
              <div class="flex-between">
                <el-input
                    v-model="formInline.sheetTopAmt1Min"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.sheetTopAmt1Max"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="TOP2客单价">
              <div class="flex-between">
                <el-input
                    v-model="formInline.sheetTopAmt2Min"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.sheetTopAmt2Max"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="TOP3客单价">
              <div class="flex-between">
                <el-input
                    v-model="formInline.sheetTopAmt3Min"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.sheetTopAmt3Max"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form
              :model="formInline"
              size="small"
              :inline="true"
              label-width="130px"
          >
            <el-form-item label="M期间消费金额">
              <div class="flex-between">
                <el-input
                    v-model="formInline.monetaryMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.monetaryMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="F期间消费次数">
              <div class="flex-between">
                <el-input
                    v-model="formInline.frequencyMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.frequencyMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="T期间的最大单">
              <div class="flex-between">
                <el-input
                    v-model="formInline.tMaxMoneyMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.tMaxMoneyMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="RMF标签">
              <div class="flex-between">
                <el-select
                    style="width: 100%"
                    multiple
                    v-model="formInline.saleTagID"
                >
                  <el-option
                      v-for="item in levelRmfList"
                      :key="item.sortIndex"
                      :value="item.sortIndex"
                      :label="item.description_CN"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="行业">
              <el-select
                  style="width: 100%"
                  multiple
                  v-model="formInline.industryID"
              >
                <el-option
                    v-for="item in definedData"
                    :key="item.userDefineID"
                    :value="item.userDefineID"
                    :label="item.description_CN"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="当前是否保级">
              <div class="flex-between">
                <el-select
                    v-model="formInline.hasRelegation"
                    placeholder="请选择"
                >
                  <el-option value="" label="所有"></el-option>
                  <el-option value="1" label="是"></el-option>

                  <el-option value="0" label="否"> </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="保级日期">
              <el-date-picker
                  v-model="protectionDate"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="当前可能降级级别">
              <div class="flex-between">
                <el-select
                    style="width: 100%"
                    multiple
                    v-model="formInline.canDegradeLvl"
                >
                  <el-option
                      v-for="item in checkbooksData"
                      :key="item.levelID"
                      :value="item.levelID"
                      :label="item.levelName_cn"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="当前可用积分">
              <div class="flex-between">
                <el-input
                    v-model="formInline.currAvailPointMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.currAvailPointMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="去年累计积分">
              <div class="flex-between">
                <el-input
                    v-model="formInline.preYearPointsMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.preYearPointsMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="今年累计积分">
              <div class="flex-between">
                <el-input
                    v-model="formInline.currYearPointsMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.currYearPointsMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="升级为VIC的时间">
              <el-date-picker
                  v-model="dateValue4"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="升级为VIC的机构">
              <el-col :span="16">
                <textarea
                    rows="8"
                    v-model="FirstVipOrgName"
                    readonly
                ></textarea>
              </el-col>
              <el-col :span="8">
                <el-button
                    style="margin-left: 10px"
                    @click="
                    (outletVisible = true),
                      (flag = 2),
                      (shopId = formInline.updateLvlOrgIds)
                  "
                >选择门店</el-button
                >
              </el-col>
            </el-form-item>
            <el-form-item label="升级为VIC的区域">
              <el-select
                  v-model="formInline.updateLvlRegionIds"
                  multiple
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in Regioncax"
                    :key="item.id"
                    :label="item.lable"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="最新升级日期">
              <el-date-picker
                  v-model="dateValue5"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="最新升级机构">
              <el-col :span="16">
                <textarea rows="8" v-model="lastLvlOrgName" readonly></textarea>
              </el-col>
              <el-col :span="8">
                <el-button
                    style="margin-left: 10px"
                    @click="
                    (outletVisible = true),
                      (flag = 3),
                      (shopId = formInline.lastLvlOrgIds)
                  "
                >选择门店</el-button
                >
              </el-col>
            </el-form-item>

            <el-form-item label="去年消费次数">
              <div class="flex-between">
                <el-input
                    v-model="formInline.prevYearSaleTimesMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.prevYearSaleTimesMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="今年消费次数">
              <div class="flex-between">
                <el-input
                    v-model="formInline.currYearSaleTimesMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.currYearSaleTimesMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="平均客单价">
              <div class="flex-between">
                <el-input
                    v-model="formInline.avgSheetAmtMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.avgSheetAmtMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="平均折扣">
              <div class="flex-between">
                <el-input
                    v-model="formInline.avgDiscountMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="formInline.avgDiscountMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="title">
        <div class="dialogTitle">
          <span>条件</span>
          <div></div>
          <div>
            <el-button @click="onSubmit(), (conditionDialog = false)"
            >查 询</el-button
            >
            <el-button @click="eliminate(), (conditionDialog = false)"
            >清除查询条件</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 中心表格 -->
    <Table
        style="margin-top: 10px"
        :tableData="tableData"
        :configTable="configTable"
        :config="config"
        ref="refsTable"
        :tableHeight="tableHeight"
        @selectChange="selectChange"
        @load="load"
    ></Table>
    <!-- 门店弹窗 -->
    <el-dialog
        append-to-body
        width="35%"
        :visible.sync="outletVisible"
        title="选择门店"
        class="store-modal"
    >
      <el-form size="mini" label-width="90px">
        <el-row v-for="(item, index) in StoreSelectionList" :key="index">
          <el-col :span="12" v-for="(myitem, myindex) in item" :key="myindex">
            <el-tree
                ref="tree"
                v-if="myitem != undefined"
                :data="[myitem]"
                show-checkbox
                node-key="ShopID"
                highlight-current
                default-expand-all
                :default-checked-keys="shopId"
                :props="defaultProps"
            >
            </el-tree>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ComButtomStore">确 定</el-button>
        <el-button @click="outletVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { TApiLogsyncProcess } from "@/api/couponsDepot.js";
import { shopQueryRegionApi } from "@/api/marketing";
import Table from "@/components/table";
import { reportFormList } from "@/api/reportForm";
import configTable from "./informations";
import {
  getcpyNo,
  checkMobile,
  checkEmail,
  dateTime,
  dateTimes,
} from "@/utils/auth";
import {
  countryApi,
  provinceApi,
  cityApi,
  definedQueryListApi,
} from "@/api/region";
import {
  custDeleteApi,
  selectMainListApi,
  insertApi,
  updateApi,
  queryAllInfoForUpateApi,
  queryLSelectApi,
  empSelectEApi,
  insertBatchApi,
  queryRmfSelectApi, selectBussinDefineApi,
} from "@/api/user";
import { shopSelectByCodeApi } from "@/api/shop";
import { regionalQuery } from "@/api/huiyuanyy"; //区域
import store from "@/store";
// import { mapState } from "vuex";

export default {
  name: "centre",
  components: {
    Table,
  },
  data() {
    return {
      memberTagList: [],
      checkbooksData: [], //会员等级
      FirstVipOrgName: "", //升级为VIC的机构
      lastLvlOrgName: "",
      flag: 0,
      dateValue: [], //注册日期
      protectionDate: [], //保级日期
      dateValue1: [], //创建日期
      // dateValue2: [], //创建日期
      dateValue3: [], //创建日期
      dateValue4: [], //创建日期
      dateValue5: [],
      StoreSelectLength: 0,
      StoredataArray: [],
      shopId: [],
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      outletVisible: false, //门店弹窗
      StoreSelectionList: [], //选择门店数据
      ServiceOrgName: "", //维护店
      Regioncax: [], //区域
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      conditionDialog: false,
      EnabledisableFormVisible: false,
      downloadData: [],
      downloadShow: false,
      configTable,
      tableHeight: "30rem",
      activeName: "first", // 默认el-tab 第一项
      modifyActiveName: "first", // 修改el-tab 默认
      optionsGender: [
        {
          value: 1,
          label: "女",
        },
        {
          value: 2,
          label: "男",
        },
      ],
      // 子女情况
      optionsChildren: [
        { value: 1, label: "有" },
        { value: 2, label: "无" },
      ],
      // 创建表单验证
      createRules: {
        lastName: [
          { required: true, message: "请输入客户姓", trigger: "blur" },
        ],
        firstName: [
          { required: true, message: "请输入客户名", trigger: "blur" },
        ],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        busskind: [{ required: true, message: "请选择业务类型", trigger: "blur" }],
        birthday: [
          {
            required: true,
            message: "请选择出生日期",
            trigger: "blur",
          },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: checkMobile,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        userEmail: [
          { type: "email", message: "请输入正确的邮箱", trigger: "blur" },
          {
            validator: checkEmail,
            message: "请输入正确的邮箱",
            trigger: "blur",
          },
        ],
        serviceOrgID: [
          { required: true, message: "请选择维护店", trigger: "change" },
        ],
        serviceEmpID: [
          { required: true, message: "请选择当前维护人", trigger: "blur" },
        ],
        registOrgID: [
          { required: true, message: "注册门店", trigger: "change" },
        ],
      },
      files: {},
      memberFreezeImport: false, //导入弹窗
      filename: "",
      // succeedInfo: {},
      // deFaultIsDerived: false,
      dialogFormVisible: false,
      modificationFormVisible: false, //修改弹窗
      deleteFormVisible: false,
      multipleSelection: undefined, //选中的数据
      // 搜索表单
      formInline: {
        cpyNO: getcpyNo(),
        pageNo: 1,
        pageSize: 50,
        pagesTotal: 0,
        total: 0,
        shopCode: "",
        // empCode: "",
        serach: "",
        cardNo: "", // 卡号
        name: "", // 姓名
        mobile: "", // 电话号码
        regionID: "", // 维护区域
        shopIds: [], // 维护店
        empCode: "", // 维护人
        regionKind: "",
        registDateStart: "", //注册开始时间
        registDateEnd: "", //注册结束时间
        lvlExpireDateStart: "", //保级开始时间
        lvlExpireDateEnd: "", //保级结束时间
        provinceName: "", //省份
        cityName: "", //城市
        levelID: "", //会员等级
        birthdayStart: "", //生日
        birthdayEnd: "", //生日
        birthMonthStart: "",
        birthMonthEnd: "",
        birthDateStart: "",
        birthDateEnd: "",
        ageMin: "",
        ageMax: "",
        lastSaleDateStart: "", //最近购买日
        lastSaleDateEnd: "", //最近购买日
        tagIds: [], //会员TAG
        isMillVIP: "", //是否商城VIP
        isServiceEmp: "", //非分配维护人
        currYearAmountMin: "", //今年消费额
        currYearAmountMax: "", //今年消费额
        prevYearAmountMin: "", //去年消费金额
        prevYearAmountMax: "", //去年消费金额
        lastYearAmountMin: "", //最近一年消费额
        lastYearAmountMax: "", //最近一年消费额
        sheetTopAmt1Min: "", //TOP1客单价
        sheetTopAmt1Max: "", //TOP1客单价
        sheetTopAmt2Min: "", //TOP2客单价
        sheetTopAmt2Max: "", //TOP2客单价
        sheetTopAmt3Min: "", //TOP3客单价
        sheetTopAmt3Max: "", //TOP3客单价
        monetaryMin: "", //M期间消费金额
        monetaryMax: "", //M期间消费金额
        frequencyMin: "", //F期间消费次数
        frequencyMax: "", //F期间消费次数
        tMaxMoneyMin: "", //T期间最大单
        tMaxMoneyMax: "", //T期间最大单
        saleTagID: "", //RMF标签
        industryID: "", //行业
        hasRelegation: "", //当前是否已保级
        canDegradeLvl: "", //当前可能降级级别
        currAvailPointMin: "", //当前可用积分
        currAvailPointMax: "", //当前可用积分
        preYearPointsMin: "", //去年累计积分
        preYearPointsMax: "", //去年累计积分
        currYearPointsMin: "", //今年累计积分
        currYearPointsMax: "", //今年累计积分
        firstVipDateStart: "", //升级为VIC的时间
        firstVipDateEnd: "", //升级为VIC的时间
        updateLvlDateStart: "", //最新升级日期
        updateLvlDateEnd: "", //最新升级日期
        updateLvlRegionIds: [], //升级为VIC的区域
        prevYearSaleTimesMin: "", //去年消费次数
        prevYearSaleTimesMax: "", //去年消费次数
        currYearSaleTimesMin: "", //今年消费次数
        currYearSaleTimesMax: "", //今年消费次数
        avgSheetAmtMin: "", //平均客单价
        avgSheetAmtMax: "", //平均客单价
        avgDiscountMin: "", //平均折扣
        avgDiscountMax: "", //平均折扣
        updateLvlOrgIds: [],
        lastLvlOrgIds: [],
      },
      config: {
        pages: 50,
        count: 1,
        loading: true,
        total: 0,
        pageNo: 1,
      },
      tableData: [], //列表数据
      loading: false,
      createdTableList: {
        registOrgCode: "", //注册门店name
        arriveShopTimeNotes: "", //注意点
        custType: "", //VIC会员
        isMillVIP: "", //商场VIP
        badRecord: "", //不良销售记录
        lastName: "", //会员姓
        firstName: "", //会员名称
        levelID: "", //会员等级
        cardNo: "", //会员卡号
        serviceOrgID: "", //维护店
        serviceEmpID: "", //当前维护人
        gender: "", //性别
        birthday: "", //出生日期
        mobile: "", //移动电话
        userEmail: "", //电子邮件
        telCode: "", //电话
        industryID: "", //行业
        countryID: "", //国家或地区
        stateID: "", //省
        cityID: "", //市
        registOrgID: "", //注册门店
        mailAddress: "", //通讯地址
        permanentAddress: "", //常驻地址
        busskind: [], //业务类型
        weChatOpenID: "", //小程序OpenID
        unionID: "", //UnionID
        currAvailPoint: "", //当期可用积分
        loseEfficacyPoints: "", //待取消积分
        currYearPoints: "", //今年累积积分
        custSourceID: "", //客户来源
        custSourceNotes: "", //客户来源-小类
        preYearPoints: "", //去年累积积分
        allPoints: "", //总累积积分
        pendingPoints: "", //待生效积分
        currExchangePoints: "", //今年已使用积分
        prevExchangePoints: "", //去年已使用积分
        currYearAmount: "", //今年消费额
        avgSheetAmt: "", //平均客单价
        currYearSaleTimes: "", //今年消费次数合计
        sheetTopAmt1: "", //Top1单价
        currTargetAmt: "", //今年目标消费额
        sheetTopAmt2: "", //Top2单价
        currTargetSaleTimes: "", //今年目标消费次数
        sheetTopAmt3: "", //Top3单价
        saleTagID: "", //VIP消费行为标签
        avgDiscount: "", //平均折扣
        isHighRB: "", //是否退换货高频
        lastSaleDate: "", //最近购买日
        saleAQty: "", //购买数量合计
        saleAAmount: "", //最近购买金额
        lastYearAmount: "", //最近365天消费额
        prevYearAmount: "", //去年消费额
        yearMaxSaleOrgList: "", //最近12个月消费次数最多门店
        prevYearSaleTimes: "", //去年消费次数合计
        currYearServSaleTimes: "", //今年维护店消费次数
        lastLvlAmount: "", //升级后累计消费
        heightID: "", //身高
        weightID: "", //体重
        topSize: "", //上衣尺码
        bottomSize: "", //下装尺码
        skirtSize: "", //裙装尺码
        shoeSize: "", //鞋码
        talkativeID: "", //客户性格类型：交流
        opionionID2: "", //客户性格类型：买单
        opionionID: "", //客户性格类型:决策
        colorPreference: "", //颜色偏好
        hasChild: "", //子女情况
        childBirthYear: "", //最小子女出生年
        religiousID: "", //宗教信仰
        custGroupID: "", //四大客户群体
        sixTypeID: "", //六小类客户群体
        referrerID: "", //推荐人
        contactInfoID: "", //联系方式添加情况
        activityLevel: "", //会员活跃度
        registDate: new Date(), //默认当前日期
        attrIDArray: [[], [], [], [], [], [], [], [], [], [], []], // 选择的数据
      }, // 新增数据
      optionsShop: [], // 门店
      searchOptions: [], // 会员等级
      MaintainerData: [], // 维护人列表
      countryData: [], // 存放国家数据
      bussBindData: [], // 存放业务类型数据
      countryValue: "", // 选择的国家
      provinceData: [], // 存放省份
      provinceValue: "", // 选择的省份
      cityData: [], // city
      definedData: [], // 行业
      sourceData: [], // 客户来源
      memberDataList: [], //会员TAG
      heightData: [],
      weightData: [], // 体重
      topData: [], // 上衣尺码
      bottomData: [], //下衣尺码
      sizeData: [], // 尺码规格
      shoeSizeData: [],
      talkativeData: [], // 客户性格交流
      checkData: [], // 客户性格买单
      decisionData: [],
      clothingStyleData: [], //着衣风格
      specialData: [], //特殊产品偏好
      preferenceData: [],
      sensitiveData: [],
      hobbyData: [],
      regularBrandData: [],
      dailyData: [], //日常
      informationData: [],
      religionData: [],
      fourGroupsData: [],
      sixGroupsData: [], // 六小类客户群体
      delArr: [], // 存放删除的数据
      contactInfoData: [], // 联系方式添加情况
      activityLevelData: [], // 会员活跃度
      jurisdiction: {
        search: false,
        create: false,
        Import: false,
        edit: false,
        delete: false,
        look: false,
        synchronization: false,
      },
      shopListes: [], //门店编码
      orgIDString: "",
      EmpIDString: "",
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      days: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      levelRmfList: [],
    };
  },
  created() {
    console.log("品牌")
    console.log(localStorage.getItem("cpyNo"))
    queryRmfSelectApi({ defineKindID: -1 }).then(
        (res) => (this.levelRmfList = res.data)
    );
    let InForMations = JSON.parse(localStorage.getItem("InForMations"));
    for (let i = 0; i < InForMations.length; i++) {
      if (InForMations[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (InForMations[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }
      if (InForMations[i].menuName == "导入") {
        this.jurisdiction.Import = true;
        continue;
      }
      if (InForMations[i].menuName == "修改会员") {
        this.jurisdiction.edit = true;
        continue;
      }
      if (InForMations[i].menuName == "同步") {
        this.jurisdiction.synchronization = true;
        continue;
      }
      if (InForMations[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
      if (InForMations[i].menuName == "查看会员") {
        this.jurisdiction.look = true;
        localStorage.setItem(
            "LookMember",
            JSON.stringify(InForMations[i].children)
        );
        continue;
      }
    }
    this.searchList();
    this.shopList();
    this.selectMembers();
    this.countryList(); //国家列表数据
    this.bussinDefineList(); //业务类型
    this.definedList(); //行业
    this.regioNalinformation();
    this.ShopqueryRegionList();
    let arrDkDs = [13];
    definedQueryListApi({ defineKindIDs: arrDkDs.join(",") }).then((res) => {
      this.memberTagList = res.data["13"] || []; // 会员TAG
    });
    // queryLSelectApi({ cpyNO: getcpyNo() }).then((res) => {
    //   this.checkbooksData = res.data;
    // });
  },
  mounted() {
    // 创建弹窗门店模糊搜索
    shopSelectByCodeApi({ shopCode: "" }).then((res) => {
      if (res.message == "success") {
        res.data.forEach((item) => {
          this.shopListes.push({
            value: item.shopCode,
            name: item.shopName,
            id: item.shopID,
          });
        });
      }
    });
  },
  methods: {
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
            .toISOString()
            .replace(/T/g, " ")
            .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    // 清除筛选条件
    eliminate() {
      this.formInline = {
        cpyNO: getcpyNo(),
        pageNo: 1,
        pageSize: 50,
        pagesTotal: 0,
        total: 0,
        shopCode: "",
        // empCode: "",
        serach: "",
        cardNo: "", // 卡号
        name: "", // 姓名
        mobile: "", // 电话号码
        regionID: "", // 维护区域
        shopIds: [], // 维护店
        empCode: "", // 维护人
        regionKind: "",
        registDateStart: "", //注册开始时间
        registDateEnd: "", //注册结束时间
        lvlExpireDateStart: "", //保级开始时间
        lvlExpireDateEnd: "", //保级结束时间
        provinceName: "", //省份
        cityName: "", //城市
        levelID: "", //会员等级
        // birthdayStart: "", //生日
        // birthdayEnd: "", //生日
        birthMonthStart: "",
        birthMonthEnd: "",
        birthDateStart: "",
        birthDateEnd: "",
        ageMin: "",
        ageMax: "",
        lastSaleDateStart: "", //最近购买日
        lastSaleDateEnd: "", //最近购买日
        tagIds: [], //会员TAG
        isMillVIP: "", //是否商城VIP
        isServiceEmp: "", //非分配维护人
        currYearAmountMin: "", //今年消费额
        currYearAmountMax: "", //今年消费额
        prevYearAmountMin: "", //去年消费金额
        prevYearAmountMax: "", //去年消费金额
        lastYearAmountMin: "", //最近一年消费额
        lastYearAmountMax: "", //最近一年消费额
        sheetTopAmt1Min: "", //TOP1客单价
        sheetTopAmt1Max: "", //TOP1客单价
        sheetTopAmt2Min: "", //TOP2客单价
        sheetTopAmt2Max: "", //TOP2客单价
        sheetTopAmt3Min: "", //TOP3客单价
        sheetTopAmt3Max: "", //TOP3客单价
        monetaryMin: "", //M期间消费金额
        monetaryMax: "", //M期间消费金额
        frequencyMin: "", //F期间消费次数
        frequencyMax: "", //F期间消费次数
        tMaxMoneyMin: "", //T期间最大单
        tMaxMoneyMax: "", //T期间最大单
        saleTagID: "", //RMF标签
        industryID: "", //行业
        hasRelegation: "", //当前是否已保级
        canDegradeLvl: "", //当前可能降级级别
        currAvailPointMin: "", //当前可用积分
        currAvailPointMax: "", //当前可用积分
        preYearPointsMin: "", //去年累计积分
        preYearPointsMax: "", //去年累计积分
        currYearPointsMin: "", //今年累计积分
        currYearPointsMax: "", //今年累计积分
        firstVipDateStart: "", //升级为VIC的时间
        firstVipDateEnd: "", //升级为VIC的时间
        updateLvlDateStart: "", //最新升级日期
        updateLvlDateEnd: "", //最新升级日期
        updateLvlRegionIds: [], //升级为VIC的区域
        prevYearSaleTimesMin: "", //去年消费次数
        prevYearSaleTimesMax: "", //去年消费次数
        currYearSaleTimesMin: "", //今年消费次数
        currYearSaleTimesMax: "", //今年消费次数
        avgSheetAmtMin: "", //平均客单价
        avgSheetAmtMax: "", //平均客单价
        avgDiscountMin: "", //平均折扣
        avgDiscountMax: "", //平均折扣
        updateLvlOrgIds: [],
        lastLvlOrgIds: [],
      };
      this.dateValue = [];
      this.protectionDate = []; //保级日期
      this.dateValue1 = [];
      // this.dateValue2 = [];
      this.dateValue3 = [];
      this.dateValue4 = [];
      this.dateValue5 = [];
      this.ServiceOrgName = ""; //维护店
      this.FirstVipOrgName = ""; //升级为VIC的机构
      this.lastLvlOrgName = "";
      this.formInline.pageNo = 1;
      this.loading = true;
      this.tableData = [];
      this.searchList();
    },
    // 选择门店
    ComButtomStore() {
      //获取已选择的门店数据
      let listOfSomeStoresl = [];
      let listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          listOfSomeStoresl.push(...this.StoredataArray[index].chlidren);
        } else {
          listOfSomeStoresl.push(...item);
        }
      }
      listOfSomeStoresl.forEach((item) => {
        listOfSomeStoreslStr += `${item.lable}\n`;
      });
      // listOfSomeStoreslStr = listOfSomeStoreslStr.substring(
      //   0,
      //   listOfSomeStoreslStr.length - 2
      // );
      let shopId = []; //选中门店数据
      for (let i = 0; i < listOfSomeStoresl.length; i++) {
        shopId.push(listOfSomeStoresl[i].id);
      }

      if (this.flag == 1) {
        this.ServiceOrgName = listOfSomeStoreslStr;
        this.formInline.shopIds = shopId;
      } else if (this.flag == 3) {
        this.lastLvlOrgName = listOfSomeStoreslStr;
        this.formInline.lastLvlOrgIds = shopId;
      } else {
        this.FirstVipOrgName = listOfSomeStoreslStr;
        this.formInline.updateLvlOrgIds = shopId;
      }
      this.outletVisible = false;
    },
    // 获取区域门店
    ShopqueryRegionList() {
      shopQueryRegionApi({ state: 1 }).then((res) => {
        let arr1 = [],
            arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.ShopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //区域渲染数据
    async regioNalinformation() {
      const res = await regionalQuery({ regionID: "" });
      this.Regioncax = res.data;
      // this.queryInfoList = res.data;
      // this.shopafter = res.data;
    },
    Synchronization() {
      if (this.multipleSelection == undefined) {
        this.$message({
          message: "请先选择数据,才能进行同步!",
          type: "warning",
        });
        return false;
      } else {
        this.EnabledisableFormVisible = true;
      }
    },
    Enabledisableqd() {
      let data = require("qs").stringify({
        id: this.multipleSelection.custID,
        type: 1,
      });
      TApiLogsyncProcess(data).then((res) => {
        if (res.success == true) {
          this.$message.success("同步成功!");
          this.EnabledisableFormVisible = false;
          this.$refs.refsTable.radio = "";
          this.multipleSelection = undefined;
        } else {
          this.$message.error("同步失败!");
        }
      });
    },
    //获取下载列表数据
    getDownladList() {
      reportFormList({
        groupName: "会员批量导入",
      }).then((response) => {
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = process.env.VUE_APP_BASE_API + src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // // 查看所有门店
    shopList() {
      shopSelectByCodeApi({ shopCode: "" }).then((res) => {
        this.optionsShop = res.data;
      });
    },
    // 会员等级
    async selectMembers() {
      const { data: res } = await queryLSelectApi({ cpyNO: getcpyNo() });
      this.searchOptions = res;
      this.checkbooksData = res;
    },
    // 维护人
    async Maintainer() {
      const { data: res } = await empSelectEApi({ orgID: this.orgIDString });
      this.MaintainerData = res;
    },
    // 查看会员
    getToLook() {
      if (this.multipleSelection == undefined)
        return this.$message.info("请选择数据,进行查看!");

      this.$router.push("/LookMember");
    },
    // 列表数据
    async searchList(type = false) {
      //注册日期
      if (this.dateValue && this.dateValue.length > 0) {
        this.formInline.registDateStart = this.renderTime(
            this.dateValue[0]
        ).substring(0, 10);
        this.formInline.registDateEnd = this.renderTime(
            this.dateValue[1]
        ).substring(0, 10);
      } else {
        this.formInline.registDateStart = "";
        this.formInline.registDateEnd = "";
      }

      // 保级日期
      if (this.protectionDate && this.protectionDate.length > 0) {
        this.formInline.lvlExpireDateStart = this.renderTime(
            this.protectionDate[0]
        ).substring(0, 10);
        this.formInline.lvlExpireDateEnd = this.renderTime(
            this.protectionDate[1]
        ).substring(0, 10);
      } else {
        this.formInline.lvlExpireDateStart = "";
        this.formInline.lvlExpireDateEnd = "";
      }

      // //创建日期
      // if (this.dateValue1 && this.dateValue1.length > 0) {
      //   this.formInline.createTimeStart = this.renderTime(
      //     this.dateValue1[0]
      //   ).substring(0, 10);
      //   this.formInline.createTimeEnd = this.renderTime(
      //     this.dateValue1[1]
      //   ).substring(0, 10);
      // } else {
      //   this.formInline.CreateTimeStart = "";
      //   this.formInline.CreateTimeEnd = "";
      // }

      // //生日
      // if (this.dateValue2 && this.dateValue2.length > 0) {
      //   this.formInline.birthdayStart = this.renderTime(this.dateValue2[0]).substring(0, 10);
      //   this.formInline.birthdayEnd = this.renderTime(this.dateValue2[1]).substring(0, 10);
      // } else {
      //   this.formInline.birthdayStart = "";
      //   this.formInline.birthdayEnd = "";
      // }
      //最近购买日
      if (this.dateValue3 && this.dateValue3.length > 0) {
        this.formInline.lastSaleDateStart = this.renderTime(
            this.dateValue3[0]
        ).substring(0, 10);
        this.formInline.lastSaleDateEnd = this.renderTime(
            this.dateValue3[1]
        ).substring(0, 10);
      } else {
        this.formInline.lastSaleDateStart = "";
        this.formInline.lastSaleDateEnd = "";
      }
      //升级为VIC的时间
      if (this.dateValue4 && this.dateValue4.length > 0) {
        this.formInline.firstVipDateStart = this.renderTime(
            this.dateValue4[0]
        ).substring(0, 10);
        this.formInline.firstVipDateEnd = this.renderTime(
            this.dateValue4[1]
        ).substring(0, 10);
      } else {
        this.formInline.firstVipDateStart = "";
        this.formInline.firstVipDateEnd = "";
      }

      //升级为VIC的时间
      if (this.dateValue5 && this.dateValue5.length > 0) {
        this.formInline.updateLvlDateStart = this.renderTime(
            this.dateValue5[0]
        ).substring(0, 10);
        this.formInline.updateLvlDateEnd = this.renderTime(
            this.dateValue5[1]
        ).substring(0, 10);
      } else {
        this.formInline.updateLvlDateStart = "";
        this.formInline.updateLvlDateEnd = "";
      }

      let queryInfo = {
        cpyNO: getcpyNo(),
        pageNo: this.formInline.pageNo,
        pageSize: this.formInline.pageSize,
        shopCode: this.formInline.shopCode,
        // empCode: this.formInline.empCode,
        serach: this.formInline.serach,
        regionKind: this.formInline.regionKind,
        cardNo: this.formInline.cardNo, // 卡号
        name: this.formInline.name, // 姓名
        mobile: this.formInline.mobile, // 电话号码
        regionID: this.formInline.regionID, // 维护区域
        shopIds: this.formInline.shopIds, // 维护店
        empCode: this.formInline.empCode, // 维护人
        registDateStart: this.formInline.registDateStart, //注册开始时间
        registDateEnd: this.formInline.registDateEnd, //注册结束时间
        lvlExpireDateStart: this.formInline.lvlExpireDateStart, //保级开始时间
        lvlExpireDateEnd: this.formInline.lvlExpireDateEnd, //保级结束时间
        provinceName: this.formInline.provinceName, //省份
        cityName: this.formInline.cityName, //城市
        levelID: this.formInline.levelID, //会员等级
        // birthdayStart: this.formInline.birthdayStart, //生日
        // birthdayEnd: this.formInline.birthdayEnd, //生日
        birthMonthStart: this.formInline.birthMonthStart,
        birthMonthEnd: this.formInline.birthMonthEnd,
        birthDateStart: this.formInline.birthDateStart,
        birthDateEnd: this.formInline.birthDateEnd,
        ageMin: this.formInline.ageMin,
        ageMax: this.formInline.ageMax,
        lastSaleDateStart: this.formInline.lastSaleDateStart, //最近购买日
        lastSaleDateEnd: this.formInline.lastSaleDateEnd, //最近购买日
        tagIds: this.formInline.tagIds, //会员TAG
        isMillVIP: this.formInline.isMillVIP, //是否商城VIP
        isServiceEmp: this.formInline.isServiceEmp, //非分配维护人
        currYearAmountMin: this.formInline.currYearAmountMin, //今年消费额
        currYearAmountMax: this.formInline.currYearAmountMax, //今年消费额
        prevYearAmountMin: this.formInline.prevYearAmountMin, //去年消费金额
        prevYearAmountMax: this.formInline.prevYearAmountMax, //去年消费金额
        lastYearAmountMin: this.formInline.lastYearAmountMin, //最近一年消费额
        lastYearAmountMax: this.formInline.lastYearAmountMax, //最近一年消费额
        sheetTopAmt1Min: this.formInline.sheetTopAmt1Min, //TOP1客单价
        sheetTopAmt1Max: this.formInline.sheetTopAmt1Max, //TOP1客单价
        sheetTopAmt2Min: this.formInline.sheetTopAmt2Min, //TOP2客单价
        sheetTopAmt2Max: this.formInline.sheetTopAmt2Max, //TOP2客单价
        sheetTopAmt3Min: this.formInline.sheetTopAmt3Min, //TOP3客单价
        sheetTopAmt3Max: this.formInline.sheetTopAmt3Max, //TOP3客单价
        monetaryMin: this.formInline.monetaryMin, //M期间消费金额
        monetaryMax: this.formInline.monetaryMax, //M期间消费金额
        frequencyMin: this.formInline.frequencyMin, //F期间消费次数
        frequencyMax: this.formInline.frequencyMax, //F期间消费次数
        tMaxMoneyMin: this.formInline.tMaxMoneyMin, //T期间最大单
        tMaxMoneyMax: this.formInline.tMaxMoneyMax, //T期间最大单
        saleTagID: this.formInline.saleTagID, //RMF标签
        industryID: this.formInline.industryID, //行业
        hasRelegation: this.formInline.hasRelegation, //当前是否已保级
        canDegradeLvl: this.formInline.canDegradeLvl, //当前可能降级级别
        currAvailPointMin: this.formInline.currAvailPointMin, //当前可用积分
        currAvailPointMax: this.formInline.currAvailPointMax, //当前可用积分
        preYearPointsMin: this.formInline.preYearPointsMin, //去年累计积分
        preYearPointsMax: this.formInline.preYearPointsMax, //去年累计积分
        currYearPointsMin: this.formInline.currYearPointsMin, //今年累计积分
        currYearPointsMax: this.formInline.currYearPointsMax, //今年累计积分
        firstVipDateStart: this.formInline.firstVipDateStart, //升级为VIC的时间
        firstVipDateEnd: this.formInline.firstVipDateEnd, //升级为VIC的时间
        updateLvlDateStart: this.formInline.updateLvlDateStart, //最新升级日期
        updateLvlDateEnd: this.formInline.updateLvlDateEnd, //最新升级日期
        updateLvlRegionIds: this.formInline.updateLvlRegionIds, //升级为VIC的区域
        prevYearSaleTimesMin: this.formInline.prevYearSaleTimesMin, //去年消费次数
        prevYearSaleTimesMax: this.formInline.prevYearSaleTimesMax, //去年消费次数
        currYearSaleTimesMin: this.formInline.currYearSaleTimesMin, //今年消费次数
        currYearSaleTimesMax: this.formInline.currYearSaleTimesMax, //今年消费次数
        avgSheetAmtMin: this.formInline.avgSheetAmtMin, //平均客单价
        avgSheetAmtMax: this.formInline.avgSheetAmtMax, //平均客单价
        avgDiscountMin: this.formInline.avgDiscountMin, //平均折扣
        avgDiscountMax: this.formInline.avgDiscountMax, //平均折扣
        updateLvlOrgIds: this.formInline.updateLvlOrgIds,
        lastLvlOrgIds: this.formInline.lastLvlOrgIds,
      };
      await selectMainListApi(require("qs").stringify(queryInfo)).then(
          (res) => {
            if (res.message == "success") {
              res.data.list.forEach((item) => {
                if (item.regionKind == 1) {
                  item.custName = `▲ ${item.custName}`;
                }
                item.custType = item.custType === 0 ? "非VIC会员" : "VIC会员";
                item.state = item.state === 0 ? "有效" : "无效";
                item.lastSaleDate =
                    item.lastSaleDate == null ? "" : item.lastSaleDate;
              });
              if (type) {
                this.tableData = [];
              }
              this.tableData = this.tableData.concat(res.data.list);
              this.formInline.pages = res.data.pages;
              this.config.loading = false;
              this.config.total = res.data.total;
              this.config.pageNo = this.formInline.pageNo;
            }
          }
      );
    },
    load() {
      this.config.loading = true;
      setTimeout(() => {
        this.config.pages += 1;
        this.formInline.pageNo += 1;
        this.$refs.refsTable.radio = "";
        this.searchList();
      }, 500);
    },
    // 选择数据
    selectChange(val) {
      this.multipleSelection = val;
      localStorage.setItem("custID", val.custID);
      store.commit("user/getcustID", val.custID);
    },
    removeSelectionRule() {},
    // 查询
    onSubmit() {
      this.config.loading = true;
      setTimeout(() => {
        this.config.pages = 1;
        this.formInline.pageNo = 1;
        this.tableData = [];
        this.searchList(true);
      }, 500);
      this.$refs.refsTable.radio = "";
      this.multipleSelection = undefined;
    },
    createDialog() {
      let createdTableLists = Object.keys(this.createdTableList);
      createdTableLists.map((item) => {
        if (
            typeof this.createdTableList[item] === "string" ||
            typeof this.createdTableList[item] === "number"
        ) {
          this.createdTableList[item] = undefined;
        }
        if (typeof this.createdTableList[item] === "boolean") {
          this.createdTableList[item] = false;
        }
      });
      for (let index = 0; index < 10; index++) {
        this.createdTableList.attrIDArray[index] = [];
      }
      this.provinceData = [];
      this.cityData = [];
      this.createdTableList.registDate = new Date();
      this.dialogFormVisible = true;
    },
    // 获取国家
    countryList() {
      countryApi().then((res) => {
        this.countryData = res.data;
      });
    },
    // 获取业务类型
    bussinDefineList() {
      selectBussinDefineApi().then((res) => {
        this.bussBindData = res.data;
      });
    },
    countryChange(val) {
      this.countryValue = val;
      this.provinceData = [];
      this.cityData = [];
      this.createdTableList.stateID = "";
      this.createdTableList.cityID = "";
      this.provinceList();
    },
    // 省份
    provinceList() {
      provinceApi({
        countryID: this.countryValue,
      }).then((res) => {
        this.provinceData = res.data;
      });
    },
    provinceChange(value) {
      this.createdTableList.cityID = "";
      this.provinceValue = value;
      this.cityList();
    },
    // 城市
    cityList() {
      cityApi({ stateID: this.provinceValue }).then((res) => {
        this.cityData = res.data;
      });
    },
    definedList() {
      let arrDkDs = [
        10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 24, 25, 26, 27, 28,
        29, 30, 31,36,-2,
      ];
      definedQueryListApi({ defineKindIDs: arrDkDs.join(",") }).then((res) => {
        this.definedData = res.data["11"] || []; // 行业
        this.sourceData = res.data["12"] || []; // 客户来源
        this.memberDataList = res.data["13"] || []; // 会员TAG
        this.heightData = res.data["21"] || []; // 身高
        this.weightData = res.data["22"] || []; // 体重
        this.sizeData = res.data["16"] || []; // 服装尺码
        this.shoeSizeData = res.data["17"] || []; // 鞋码
        this.talkativeData = res.data["20"] || []; // 交流
        this.checkData = res.data["19"] || []; // 买单
        this.decisionData = res.data["18"] || []; // 决策
        this.specialData = res.data["10"] || []; // 特殊产品偏好
        this.clothingStyleData = res.data["15"] || []; // 着衣风格
        this.preferenceData = res.data["14"] || []; // 到店时间偏好
        this.sensitiveData = res.data["24"] || []; // 邀约敏感点
        this.hobbyData = res.data["25"] || []; // 兴趣爱好
        this.regularBrandData = res.data["26"] || []; // 经常穿着品牌
        this.dailyData = res.data["27"] || []; // 日常奢侈品购买渠道
        this.informationData = res.data["28"] || []; // 奢侈品信息获取渠道
        this.religionData = res.data["29"] || []; // 宗教信仰
        this.fourGroupsData = res.data["30"] || []; // 四大客户群体
        this.sixGroupsData = res.data["31"] || []; // 六小类客户群体
        this.contactInfoData = res.data["36"] || []; // 联系方式添加情况
        this.activityLevelData = res.data["-2"] || []; // 会员活跃度
      });
    },
    // 创建保存
    createTableSave() {
      let attrID = [];
      this.createdTableList.attrIDArray.map((item) => {
        if (item.length > 0) attrID.push(...item);
      });


      if(this.EmpIDString==null||this.EmpIDString==''){
        this.$message.warning("请选择正确的注册门店");
        return ;
      }
      if(this.orgIDString==null||this.orgIDString==''){
        this.$message.warning("请选择正确的维护店");
        return ;
      }
      let cList = {
        lastName: this.createdTableList.lastName,
        firstName: this.createdTableList.firstName,
        gender: this.createdTableList.gender,
        birthday: dateTimes(this.createdTableList.birthday), //出生日期
        mobile: this.createdTableList.mobile,
        userEmail: this.createdTableList.userEmail,
        telCode: this.createdTableList.telCode,
        industryID: this.createdTableList.industryID, //行业
        countryID: this.createdTableList.countryID, //国家
        stateID: this.createdTableList.stateID,
        cityID: this.createdTableList.cityID,
        mailAddress: this.createdTableList.mailAddress,
        permanentAddress: this.createdTableList.permanentAddress,
        busskind: this.createdTableList.busskind,
        levelID: this.createdTableList.levelID, //会员等级
        cardNo: this.createdTableList.cardNo, //会员卡号
        serviceOrgID: this.orgIDString, //维护店ID
        serviceEmpID: this.createdTableList.serviceEmpID, //维护人
        registOrgID: this.EmpIDString, //注册门店ID
        registDate: dateTime(this.createdTableList.registDate), //注册日期
        custSourceID: this.createdTableList.custSourceID,
        custSourceNotes: this.createdTableList.custSourceNotes, //顾客来源-小类
        isHighRB: this.createdTableList.isHighRB, //是否高频退货
        heightID: this.createdTableList.heightID,
        weightID: this.createdTableList.weightID,
        topSize: this.createdTableList.topSize,
        bottomSize: this.createdTableList.bottomSize,
        skirtSize: this.createdTableList.skirtSize,
        shoeSize: this.createdTableList.shoeSize,
        talkativeID: this.createdTableList.talkativeID, //交流
        opionionID2: this.createdTableList.opionionID2, //买单
        opionionID: this.createdTableList.opionionID, //决策
        colorPreference: this.createdTableList.colorPreference,
        attrID: attrID.join(),
        hasChild: this.createdTableList.hasChild, //子女情况
        childBirthYear: this.createdTableList.childBirthYear,
        religiousID: this.createdTableList.religiousID, //宗教
        badRecord: this.createdTableList.badRecord,
        custGroupID: this.createdTableList.custGroupID, //四大客户群体
        sixTypeID: this.createdTableList.sixTypeID,
        arriveShopTimeNotes: this.createdTableList.arriveShopTimeNotes,
      };

      this.$refs.ruleFormRef.validate((valid) => {
        if (valid) {

          insertApi(require("qs").stringify(cList)).then((res) => {
            if (res.success == true) {
              this.$message.success("添加成功!");
              this.tableData = [];
              this.config.count = 1;
              this.orgIDString = ""; //维护店ID
              this.EmpIDString = ""; //注册门店ID
              this.createdTableList.birthday = "";
              this.dialogFormVisible = false;
              this.searchList();
            } else {
              this.$message.error("创建失败!");
            }
          });
        } else {
          return false;
        }
      });
    },
    cancelBtn() {
      this.dialogFormVisible = false;
      this.$refs.ruleFormRef.resetFields();
    },
    // 选择会员Tag
    changeTAG(val) {
      this.createdTableList.attrIDArray[0] = val;

    },
    // 选择的特殊产品偏好数据
    changeSpecial(val) {
      this.createdTableList.attrIDArray[1] = val;

    },
    // 客户着衣风格
    changeClothingStyle(val) {
      this.createdTableList.attrIDArray[2] = val;

    },
    // 到店时间偏好
    changePreferenceData(val) {
      this.createdTableList.attrIDArray[3] = val;

    },
    // 邀约敏感点
    changeStyle(val) {
      this.createdTableList.attrIDArray[4] = val;

    },
    // 兴趣爱好
    changeClothing(val) {
      this.createdTableList.attrIDArray[5] = val;

    },
    // 经常穿着品牌
    changePinPai(val) {
      this.createdTableList.attrIDArray[6] = val;

    },
    // 日常奢侈品购买渠道
    changePFD(val) {
      this.createdTableList.attrIDArray[7] = val;

    },
    // 奢侈品信息获取渠道
    changeQuDao(val) {
      this.createdTableList.attrIDArray[8] = val;

    },
    // 联系方式添加情况
    changeContactInfo(val) {

      this.createdTableList.attrIDArray[9]=[];
      this.createdTableList.attrIDArray[9].push(val);
      this.contactInfoID=val;

    },
    // 会员活跃度
    changeActivityLevel(val) {

      this.createdTableList.attrIDArray[10]=[];
      this.createdTableList.attrIDArray[10].push(val);
      this.activityLevel=val;

    },
    // 修改查看会员信息
    lookHuiYuan() {
      queryAllInfoForUpateApi({
        custID: this.multipleSelection.custID,
      }).then((res) => {
        if (!res.success) return;
        res.data.isMillVIP = res.data.isMillVIP == 1 ? true : false;
        res.data.industryID = res.data.industryID
            ? res.data.industryID * 1
            : res.data.industryID;

        Object.assign(this.createdTableList, res.data);

        this.createdTableList.shoeSize = this.createdTableList.shoeSize
            ? parseInt(this.createdTableList.shoeSize)
            : undefined;
        this.createdTableList.topSize = this.createdTableList.topSize
            ? parseInt(this.createdTableList.topSize)
            : undefined;
        this.createdTableList.bottomSize = this.createdTableList.bottomSize
            ? parseInt(this.createdTableList.bottomSize)
            : undefined;
        this.createdTableList.skirtSize = this.createdTableList.skirtSize
            ? parseInt(this.createdTableList.skirtSize)
            : undefined;

        let selectIds = Object.keys(res.select);
        selectIds.map((item) => {
          if (res.select[item].length > 0) {
            let arrays = [];
            res.select[item].map((myitem) => {
              if (myitem.selectExist) {
                arrays.push(myitem.userDefineID);
              }
            });
            if (item == 13) this.createdTableList.attrIDArray[0] = arrays;
            if (item == 10) this.createdTableList.attrIDArray[1] = arrays;
            if (item == 15) this.createdTableList.attrIDArray[2] = arrays;
            if (item == 14) this.createdTableList.attrIDArray[3] = arrays;
            if (item == 24) this.createdTableList.attrIDArray[4] = arrays;
            if (item == 25) this.createdTableList.attrIDArray[5] = arrays;
            if (item == 26) this.createdTableList.attrIDArray[6] = arrays;
            if (item == 27) this.createdTableList.attrIDArray[7] = arrays;
            if (item == 28) this.createdTableList.attrIDArray[8] = arrays;
            if (item == 36) {this.createdTableList.attrIDArray[9] = arrays ;
              if(arrays!=null && arrays.length>0){
                this.createdTableList.contactInfoID=arrays[0];
              }
            }
            if (item == -2) {this.createdTableList.attrIDArray[10] = arrays ;
              if(arrays!=null && arrays.length>0){
                this.createdTableList.activityLevel=arrays[0];
              }
            }
          }
        });

        if (res.data.tBussindefineList.length > 0) {
          let busskindParam=[];
          res.data.tBussindefineList.forEach((item) => {
            busskindParam.push(item.busskind);
          });
          this.createdTableList.busskind=busskindParam;
        }
        this.countryValue = res.data.countryID;
        this.provinceValue = res.data.stateID;
        if (this.countryValue) {
          this.provinceList();
        }
        if (this.provinceValue) {
          this.cityList();
        }
      });
    },
    //
    // 修改
    modifyBtn() {
      if (this.multipleSelection == undefined || this.multipleSelection == {}) {
        return this.$message.info("请选择数据!");
      } else {
        let createdTableLists = Object.keys(this.createdTableList);

        createdTableLists.map((item) => {
          if (
              typeof this.createdTableList[item] === "string" ||
              typeof this.createdTableList[item] === "number"
          ) {
            this.createdTableList[item] = undefined;
          }
          if (typeof this.createdTableList[item] === "number") {
            this.createdTableList[item] = undefined;
          }
        });
        this.provinceData = [];
        this.cityData = [];
        this.lookHuiYuan();
        this.modificationFormVisible = true;
      }
    },
    modifyBtnSave() {
      let attrID = [];
      this.createdTableList.attrIDArray.map((item) => {
        if (item.length > 0) attrID.push(...item);
      });
      let modifySaveList = {
        custID: this.multipleSelection.custID,
        lastName: this.createdTableList.lastName,
        firstName: this.createdTableList.firstName, // 客户名
        levelID: this.createdTableList.levelID, //会员等级
        cardNo: this.createdTableList.cardNo, //会员卡号
        serviceOrgID: this.createdTableList.serviceOrgID,
        serviceEmpID: this.createdTableList.serviceEmpID, //维护人
        busskind: this.createdTableList.busskind.join(","),
        gender: this.createdTableList.gender,
        birthday: dateTimes(this.createdTableList.birthday), //出生日期
        mobile: this.createdTableList.mobile,
        userEmail: this.createdTableList.userEmail,
        telCode: this.createdTableList.telCode,
        industryID: this.createdTableList.industryID, //行业
        countryID: this.createdTableList.countryID, //国家
        stateID: this.createdTableList.stateID,
        cityID: this.createdTableList.cityID,
        mailAddress: this.createdTableList.mailAddress,
        permanentAddress: this.createdTableList.permanentAddress,
        weChatOpenID: this.createdTableList.weChatOpenID, //小程序OpenID
        unionID: this.createdTableList.unionID,
        currAvailPoint: this.createdTableList.currAvailPoint, //当期可用积分
        loseEfficacyPoints: this.createdTableList.loseEfficacyPoints, //待取消积分
        registOrgID: this.createdTableList.registOrgID, //注册门店
        registDate: dateTime(this.createdTableList.registDate), //注册日期
        updateLvlOrgID: this.createdTableList.updateLvlOrgID, //最新升级门店
        updateLvlDate: this.createdTableList.updateLvlDate,
        lvlStartDate: this.createdTableList.lvlStartDate, //保级起始日期
        LvlExpireDate: this.createdTableList.LvlExpireDate,
        custSourceID: this.createdTableList.custSourceID,
        custSourceNotes: this.createdTableList.custSourceNotes, //顾客来源-备注
        isMillVIP: this.createdTableList.isMillVIP ? 1 : 2,
        custType: Number(this.createdTableList.custType), //VIC会员
        referrerID: this.createdTableList.referrerID, //推荐人
        lvlAmount: this.createdTableList.lvlAmount,
        heightID: this.createdTableList.heightID,
        weightID: this.createdTableList.weightID,
        topSize: this.createdTableList.topSize,
        bottomSize: this.createdTableList.bottomSize,
        skirtSize: this.createdTableList.skirtSize,
        shoeSize: this.createdTableList.shoeSize,
        talkativeID: this.createdTableList.talkativeID, //交流
        opionionID2: this.createdTableList.opionionID2, //买单
        opionionID: this.createdTableList.opionionID, //决策
        colorPreference: this.createdTableList.colorPreference,
        attrID: attrID.join(","),
        hasChild: this.createdTableList.hasChild, //子女情况
        childBirthYear: this.createdTableList.childBirthYear,
        religiousID: this.createdTableList.religiousID, //宗教
        badRecord: this.createdTableList.badRecord,
        custGroupID: this.createdTableList.custGroupID, //四大客户群体
        sixTypeID: this.createdTableList.sixTypeID,
        arriveShopTimeNotes: this.createdTableList.arriveShopTimeNotes,
      };

      updateApi(require("qs").stringify(modifySaveList)).then((res) => {
        if (res.success == true) {
          this.$message.success("修改成功!");
          this.modificationFormVisible = false;
          this.tableData = [];
          this.config.count = 1;
          this.$refs.refsTable.radio = "";
          this.multipleSelection = undefined;
          this.searchList();
        }
      });
    },
    // 删除弹窗
    deletePopup() {
      if (this.multipleSelection == undefined) {
        this.$message.info("请选择删除的数据!");
      } else {
        this.deleteFormVisible = true;
      }
    },
    // 删除
    async deleteForm() {
      await custDeleteApi({ custID: this.multipleSelection.custID }).then(
          (res) => {
            if (res.message == "success") {
              this.$message.success("删除成功!");
              this.deleteFormVisible = false;
              this.tableData = [];
              this.formInline.total = 0;
              this.config.pages = 1;
              this.formInline.pageNo = 1;
              this.$refs.refsTable.radio = "";
              this.multipleSelection = undefined;
              this.searchList();
            } else {
              this.$message.error("删除失败!");
            }
          }
      );
    },
    // 选择上传
    handleExcel(file) {
      this.filename = file.name;
      let formData = new FormData(); //声明一个FormDate对象
      formData.append("file", file.raw); //添加文件对象
      //调用后台导入的接口
      insertBatchApi(formData).then((res) => {
        if (res.success) {
          this.$message.success("导入成功请在下载列表查看");
          this.memberFreezeImport = false;
          // this.deFaultIsDerived = true;
          // this.succeedInfo = res.data;
          // this.searchList()
        } else {
          // this.deFaultIsDerived = true;
          this.$message({
            type: "error",
            message: "导入失败,请重新导入!",
          });
        }
      });
    },
    // //下载导入成功excel
    // downFile () {
    //   const ele = document.createElement("a");
    //   ele.style.display = "none";
    //   // 设置href属性为文件路径，download属性可以设置文件名称
    //   ele.href = "https://gftest.redstone.com.cn/" + this.succeedInfo.fileUrl;
    //   ele.download = "";
    //   // 将a标签添加到页面并模拟点击
    //   document.querySelectorAll("body")[0].appendChild(ele);
    //   ele.click();
    //   // 移除a标签
    //   ele.remove();
    // },
    // beforeUpload(file) {
    //   //文件类型
    //   const isType = file.type === "application/vnd.ms-excel";
    //   const isTypeComputer =
    //     file.type ===
    //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    //   const fileType = isType || isTypeComputer;
    //   if (!fileType) {
    //     this.$message.error("上传文件只能是xls/xlsx格式!");
    //   }
    //   // 文件大小限制为10M
    //   const fileLimit = file.size / 1024 / 1024 < 10;
    //   if (!fileLimit) {
    //     this.$message.error("上传文件大小不超过10M!");
    //   }
    //   return fileType && fileLimit;
    // },
    // 后端给的下载模板接口----前端进行下载
    downloadTemplateBtn() {
      const e = document.createElement("a");
      e.style.display = "none";
      // 设置href属性为文件路径，download属性可以设置文件名称
      e.href =
          process.env.VUE_APP_BASE_API + "/api/templates/会员导入模板.xlsx";
      e.download = "";
      // 将a标签添加到页面并模拟点击
      document.querySelectorAll("body")[0].appendChild(e);
      e.click();
      // 移除a标签
      e.remove();
    },
    querySearch(queryString, cb) {
      var shopList = this.shopListes;
      var results = queryString
          ? shopList.filter(this.createFilter(queryString))
          : shopList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (shoplis) => {
        return (
            shoplis.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(cur) {
      this.createdTableList.serviceEmpID = "";
      this.orgIDString = cur.id;
      this.Maintainer();
    },
    handleSelecting(back) {
      this.EmpIDString = back.id;
    },
    handleSelectest(k) {
      this.createdTableList.registOrgID = k.id;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__header {
  background-color: #f3f1dd;
}
/deep/.el-dialog__footer {
  height: 60px;
  background-color: #f2f2f2;
}

.header-text {
  height: 1.875rem;
  margin-top: 0.625rem;
  color: #76734f;
}
.header {
  margin: 0.5rem;
}
.searchform {
  margin-top: 0.625rem;
}
.centercard {
  margin-top: 0.625rem;
}
.card-pagination {
  margin-top: 0.625rem;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 0.4375rem;
  color: #a19b59;
}

// input框的圆角取消
/deep/input {
  border-radius: 0;
}
// 去除表头复选框
// /deep/.table-style {
//   .el-table-column--selection.is-leaf .el-checkbox {
//     display: none;
//   }
// }

::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }
  .el-table .success-row {
    background: #ffffff;
  }

  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 0.875rem;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }

  // 创建弹窗样式和修改会员弹窗样式
  .establish,
  .modification {
    .el-dialog__header,
    .el-message-box__header {
      height: 2.75rem;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 1.25rem;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 0.875rem !important;
    }

    /* Dialog对话框 公共部分样式 End*/

    .el-tabs__item.is-active {
      color: #817b23;
    }
    .el-tabs__item:hover {
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 3.75rem;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-dialog__body {
      padding: 0.625rem 1.25rem;
    }

    .el-button:hover {
      background-color: #b6b388;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 0.5625rem;
      border-top-right-radius: 0.5625rem;
      height: 2.75rem;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 1.25rem;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 1rem !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 1.25rem;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 1.875rem 3.75rem;
    }
    .el-tabs__item {
      border: 0.0625rem solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 3.75rem;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0rem;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // .el-tabs .el-tabs--card .el-tabs--top{
  //   height: 30%;
  // }
  // .el-tabs__item .is-top .is-active{
  //   height: 380px;
  // }
  .import {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 10px 30px 20px 30px;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .dialogTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 50px;
  }
  .dialogTitle > span {
    font-size: 16px;
    font-weight: 700;
    color: #6c6937;
  }
}


.el-radio__original {

  display: none !important; /* 隐藏原生 radio 输入，但仍然允许交互 */

}

</style>
